/**
 * This file contains all the queries that are used in the application.
 */

// Query to get all categories
export const getCategoriesV2 = `
  query GetCategoriesV2 {
    getCategoriesV2 {
      name
      weight
    }
  }
`;

// Query to get events by day
export const getEventsByDay = `
  query GetEventsByDay($day: Int!, $month: Int!) {
    getEventsByDay(day: $day, month: $month) {
      categories
      categoriesV2
      description
      images
      name
      sortKey
      source
      isTaxiAvailable
      location {
        address
        city
        description
        latitude
        longitude
        name
        phone
        tips
        type
        url
        zip
        validLocation
      }
      occurrences {
        end
        start
        url
      }
    }
  }
`;

// Query to get all locations
export const getLocations = `
  query GetLocations {
    getLocations {
      address
      city
      description
      latitude
      longitude
      name
      phone
      tips
      type
      url
      zip
      validLocation
    }
  }
`;

// Query to get locations by type
export const getLocationsByType = `
  query GetLocationsByType($type: String!) {
    getLocationsByType(type: $type) {
      address
      city
      description
      latitude
      longitude
      name
      phone
      tips
      type
      url
      zip
      validLocation
    }
  }
`;

// Query to get parking details
export const getParking = `
  query GetParking {
    getParking {
      address
      freeSpaces
      id
      lastUpdated
      latitude
      longitude
      name
      occupiedSpaces
      totalSpaces
      type
      zone
      text2Pay
      isTaxiAvailable
      isActive
      parkwhiz
    }
  }
`;

// Query to search events by location
export const searchEventsByLocation = `
  query SearchEventsByLocation($locationName: String!, $startDay: Int!, $month: Int!) {
    searchEventsByLocation(locationName: $locationName, month: $month, startDay: $startDay) {
      categories
      categoriesV2
      description
      images
      name
      sortKey
      source
      isTaxiAvailable
      location {
        address
        city
        description
        latitude
        longitude
        name
        phone
        tips
        type
        url
        zip
        validLocation
      }
      occurrences {
        end
        start
        url
      }
    }
  }
`;

// Query to search events by name
export const searchEventsByName = `
  query SearchEventsByName($eventName: String!, $month: Int!, $startDay: Int!) {
    searchEventsByName(eventName: $eventName, month: $month, startDay: $startDay) {
      categories
      categoriesV2
      description
      searchDescription
      images
      name
      sortKey
      source
      isTaxiAvailable
      location {
        address
        city
        description
        latitude
        longitude
        name
        phone
        tips
        type
        url
        zip
        validLocation
      }
      occurrences {
        end
        start
        url
      }
    }
  }
`;

// Query to get events by location and days
export const getEventsByLocationDays = `
  query GetEventsByLocationDays($locationName: String!) {
    getEventsByLocationDays(locationName: $locationName) {
      categories
      categoriesV2
      description
      searchDescription
      images
      name
      sortKey
      source
      isTaxiAvailable
      occurrences {
        end
        start
        url
      }
      location {
        address
        city
        description
        latitude
        longitude
        name
        phone
        tips
        type
        url
        zip
        validLocation
      }
    }
  }
`;

export const getEvents = `
  query GetEvents($searchInput: String, $tokenInput: String, $fromDate: AWSDateTime, $toDate: AWSDateTime, $categories: [String]) {
    getEvents(searchString: $searchInput, nextToken: $tokenInput, fromDate: $fromDate, toDate: $toDate, categories: $categories) {
      items {
        categories
        categoriesV2
        description
        searchDescription
        images
        name
        sortKey
        source
        isTaxiAvailable
        location {
          address
          city
          description
          latitude
          longitude
          name
          phone
          tips
          type
          url
          zip
          validLocation
        }
        occurrences {
          end
          start
          url
          formatted {
            endDate
            endTime
            startDate
            startTime
            shortEndDate
            shortStartDate
            times
        }
        }
        images
      }
      totalFound
      hasMore
      nextToken
    }
  }
`;

export const getEventDetails = `
  query GetEventDetails($inputEventKey: String) {
    getEventDetails(eventKey: $inputEventKey) {
      item {
        categories
        categoriesV2
        images
        description
        searchDescription
        name
        sortKey
        source
        isTaxiAvailable
        location {
          address
          city
          description
          latitude
          longitude
          name
          phone
          tips
          type
          url
          zip
          validLocation
        }
        occurrences {
          end
          start
          url
          formatted {
            endDate
            endTime
            startDate
            startTime
            shortEndDate
            shortStartDate
            times
        }
        }
      }
      validationMessages
      error
    }
  }
`;

// Query to get featured events
export const getFeaturedEvents = `
query getFeaturedEvents {
  getFeaturedEvents {
    categories
    categoriesV2
    description
    images
    isTaxiAvailable
    location {
      address
      city
      description
      latitude
      longitude
      name
      phone
      tips
      type
      url
      validLocation
      zip
    }
    name
    sortKey
    source
    occurrences {
      end
      formatted {
        endDate
        endTime
        shortEndDate
        shortStartDate
        startDate
        startTime
        times
      }
      start
      url
    }
  }
}`;
